import 'unfetch/polyfill'; // ensure IE11 works with fetch

import ScrollController from '../../../assets/js/controllers/scroll';
import SkrolliteController from '../../../assets/js/controllers/skrollite';

export default class GridArticlesLoadMore {

	static selector = '[data-grid-articles-tab]';

	// class variables

	attributes = {};

	config = {};

	controllers = {
		resize: null
	};

	el = {};

	dataSets = {
		articleGrid: []
	}

	// constructor

	constructor(container) {
		this.el = {
			container,

			// singles
			articleGridSeeMore: container.querySelector('[data-grid-articles-see-more]'),
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		this.#onArticleGridLoad();
	}

	// event listeners
	#addEventListeners = () => {
		this.el.articleGridSeeMore.addEventListener('click', this.#onArticleSeeMoreClick);
	}

	#removeEventListeners = () => {
		this.el.articleGridSeeMore.removeEventListener('click', this.#onArticleSeeMoreClick);
	}

	#onArticleGridLoad = () => {

		const category = this.el.articleGridSeeMore.getAttribute('data-parent-category-id'),
			year = this.el.articleGridSeeMore.getAttribute('data-year'),
			temp = this;

		if (!this.dataSets.articleGrid[category]) {
			fetch(`/api/press-articles.json?parentCategory=${category}&year=${year}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
				.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
				.then(response => {
					if (response.data && response.data.length) {
						this.dataSets.articleGrid[category] = response.data;
					} else {
						temp.articleGridBuildMoreHtml([], this.el.articleGridSeeMore);
					}
				})
				.catch(() => {
					temp.articleGridBuildMoreHtml([], this.el.articleGridSeeMore);
				});
		}
	}

	#onArticleSeeMoreClick = (e) => {
		e.preventDefault();

		const category = e.target.getAttribute('data-parent-category-id'),
			year = e.target.getAttribute('data-year'),
			temp = this;

		if (this.dataSets.articleGrid[category]) {
			temp.articleGridBuildMoreHtml(this.dataSets.articleGrid[category], e.target);
		} else {
			fetch(`/api/press-articles.json?parentCategory=${category}&year=${year}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
				.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
				.then(response => {
					if (response.data && response.data.length) {
						temp.articleGridBuildMoreHtml(response.data, e.target);
					} else {
						temp.articleGridBuildMoreHtml([], e.target);
					}
				})
				.catch(() => {
					temp.articleGridBuildMoreHtml([], e.target);
				});
		}
	}

	articleGridBuildMoreHtml = (data, $appendBeforeEl) => {
		const hasResults = (data.length > 0);

		if (hasResults) {

			// organize the categories
			let categories = [],

				yearGroup = null,
				yearMonths = [],
				lastYear = null,

				monthGroup = null,
				monthArticles = [],
				lastMonth = null;

			for (let i = data.length - 1; i >= 0; i--) {

				const categoryItem = data[i],
					isExcluded = (categoryItem.seoMeta && (categoryItem.seoMeta.excludeFromSearchAndFilters === true)),
					hasExcerpt = (categoryItem.excerptPressListing || categoryItem.excerptResourceListing);

				if (!isExcluded && hasExcerpt) {

					let postDate = (categoryItem.date) ? categoryItem.date.date : categoryItem.dateUpdated.date;
					postDate = postDate.replace(/ /g, 'T');
					const year = new Date(postDate),
						month = new Date(postDate);

					if (lastYear && (year.getFullYear() !== lastYear.getFullYear())) {
						// store months data
						if (lastMonth) {
							monthGroup = {
								month: lastMonth,
								articles: monthArticles
							};
							yearMonths = yearMonths.concat([monthGroup]);
						}

						// store years data #}
						if (lastYear) {
							yearGroup = {
								year: lastYear,
								months: yearMonths
							};
							categories = categories.concat([yearGroup]);
						}

						// clear data for next loop

						// clear month data
						monthGroup = null;
						monthArticles = [];

						// clear year data
						yearGroup = null;
						yearMonths = [];
					} else {
						// if month has changed, store old group and create new #}

						if ((lastMonth) && month.getMonth() !== lastMonth.getMonth()) {
							if (lastMonth) {
								monthGroup = {
									month: lastMonth,
									articles: monthArticles
								};
								yearMonths = yearMonths.concat([monthGroup]);
							}

							monthGroup = null;
							monthArticles = [];
						}
					}

					// add current article to this month's array of articles
					monthArticles = monthArticles.concat([categoryItem]);

					// store this loop's month and year
					lastMonth = month;
					lastYear = year;
				} // endif
			} // end for loop

			// after loop, populate one last time
			monthGroup = {
				month: lastMonth,
				articles: monthArticles
			};
			yearMonths = yearMonths.concat([monthGroup]);

			yearGroup = {
				year: lastYear,
				months: yearMonths
			};
			categories = categories.concat([yearGroup]);

			// Now Build HTML from new categories array
			let articlesHtml = '';
			for (let i = categories.length - 1; i >= 0; i--) {

				const categoryItem = categories[i];

				articlesHtml += `
						<div class="grid-articles__articles-by-year-col grid-articles__articles-by-year-col--year">
							<h2 class="mono" data-sticky data-sticky-offset="25">${categoryItem.year.getFullYear()}</h2>
						</div>
						<div class="grid-articles__articles-by-year-col grid-articles__articles-by-year-col--content">`;

							const monthsSorted = categoryItem.months; // |sort((a, b) => a <=> b)|reverse

							for (let ii = monthsSorted.length - 1; ii >= 0; ii--) {

								const month = monthsSorted[ii],
									monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(month.month);

				articlesHtml += `<div class="grid-articles__articles-by-month">
									<div class="grid-articles__articles-by-month-col grid-articles__articles-by-month-col--month">
										<span class="copy--number">${monthName}</span>
									</div>
									<div class="grid-articles__articles-by-month-col grid-articles__articles-by-month-col--content">`;
										for (let iii = month.articles.length - 1; iii >= 0; iii--) {

											const article = month.articles[iii];
											let postDate = (article.date) ? article.date.date : article.dateUpdated.date;
											postDate = postDate.replace(/ /g, 'T');
											postDate = new Date(postDate);
											const isLinkExternal = (article.externalLink),
												articleExcerpt = (article.excerptPressListing) ? article.excerptPressListing : article.excerptResourceListing,
												supheading = (articleExcerpt.supheading) ? articleExcerpt.supheading : article.parentCategoryName,
												articleHref = isLinkExternal ? article.externalLink : article.url,
												articleTarget = isLinkExternal ? '_blank' : '_self',
												dayTwoDigit = new Intl.DateTimeFormat('en-US', { day: '2-digit', }).format(postDate);
				articlesHtml += 		`<article class="grid-articles__article" data-hover-detector data-skrollite>
												<div class="grid-articles__article-col--day">
													<span class="copy--number">— ${dayTwoDigit}</span>
												</div>
												<div class="grid-articles__article-col--content">
													<div class="grid-articles__article-col-content-meta">
														<span class="grid-articles__article-col-content-meta-month copy--number">${monthName}</span>
														<span class="grid-articles__article-col-content-meta-day copy--number">— ${dayTwoDigit}</span>
														<span class="grid-articles__article-col-content-meta-supheading copy--meta">[${supheading}]</span>
													</div>
													<a class="grid-articles__article-col-content-heading" href="${articleHref}" target="${articleTarget}" data-hover-detector-item>
														<h3 class="animation-heading">${article.title}</h3>`;
														if (isLinkExternal && articleExcerpt.description) {
				articlesHtml +=								`<p class="large">${articleExcerpt.description}</p>`;
														}
				articlesHtml += 					'</a>';
													if (!isLinkExternal) {
				articlesHtml +=							`<a href="${articleHref}" target="${articleTarget}" class="cta cta-circle-arrow-right grid-articles__article-cta is-red is-small" data-hover-detector-item aria-label="Click to View Article">
															<span class="a11y">Click to View Article</span>
															<figure class="cta-circle-arrow-right__arrow">
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.4 9.9">
																<polygon points="4.5,0 3.8,0.7 7.5,4.4 0,4.4 0,5.4 7.5,5.4 3.8,9.2 4.5,9.9 9.4,4.9 "/>
																</svg>
															</figure>
															<figure class="cta-circle-arrow-right__arrow-hover">
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.4 9.9">
																<polygon points="4.5,0 3.8,0.7 7.5,4.4 0,4.4 0,5.4 7.5,5.4 3.8,9.2 4.5,9.9 9.4,4.9 "/>
																</svg>
															</figure>
															<figure class="cta-circle-arrow-right__outline"></figure>
														</a>`;
													}
				articlesHtml +=				`</div>
											</article>`;
										} // end for loop
									articlesHtml += `</div>
								</div>`;
							} // end for loop
						articlesHtml += `</div>
					`;
			} // end for loop

			const thisWrapper = document.createElement('div');
			thisWrapper.setAttribute('class', 'grid-articles__articles-by-year');
			thisWrapper.innerHTML = articlesHtml;
			const par = $appendBeforeEl.closest('.grid-articles__articles-wrapper');
			par.insertBefore(thisWrapper, $appendBeforeEl);

			// Update Button data for previous year
			const prevYear = $appendBeforeEl.getAttribute('data-year') - 1;
			const category = $appendBeforeEl.getAttribute('data-parent-category-id');

			// Refresh Skrollite/Stickies/etc.
			ScrollController.refresh();
			ScrollController.updateChildren();
			ScrollController.gatherStickies();
			ScrollController.updateStickies();
			SkrolliteController.pageUpdate();

			const temp = this;
			// Fetch prev year's data to see if there is any:
			fetch(`/api/press-articles.json?&parentCategory=${category}&year=${prevYear}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
				.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
				.then(response => {
					if (response.data && response.data.length > 0) {
						temp.dataSets.articleGrid[category] = null;
						temp.dataSets.articleGrid[category] = response.data;
						$appendBeforeEl.setAttribute('data-year', prevYear);
						$appendBeforeEl.textContent = `More Articles (${prevYear})`;
					} else {
						temp.dataSets.articleGrid[category] = null;
						$appendBeforeEl.setAttribute('data-year', prevYear);
						$appendBeforeEl.textContent = 'No More Articles';
						$appendBeforeEl.setAttribute('disabled', 'disabled');
						$appendBeforeEl.setAttribute('style', 'display:none;');
					}
				})
				.catch(() => {
					temp.addClass($appendBeforeEl, 'hidden');
					$appendBeforeEl.setAttribute('disabled', 'disabled');
					$appendBeforeEl.setAttribute('style', 'display:none;');
				});

		} else {
			const category = $appendBeforeEl.getAttribute('data-parent-category-id');
			const prevYear = $appendBeforeEl.getAttribute('data-year') - 1;
			this.dataSets.articleGrid[category] = null;
			$appendBeforeEl.setAttribute('data-year', prevYear);
			$appendBeforeEl.textContent = 'No More Articles';
			$appendBeforeEl.setAttribute('disabled', 'disabled');
			$appendBeforeEl.setAttribute('style', 'display:none;');
		}
	}

	hasClass(el, className) {
		return el.classList ? el.classList.contains(className) : new RegExp(`\\b${className}\\b`).test(el.className);
	}

	addClass(el, className) {
		if (el.classList) {
			el.classList.add(className);
		} else if (!this.hasClass(el, className)) {
			el.className += ` ${className}`;
		}
	}

	// destroy
	destroy() {
		this.#removeEventListeners();
	}

}
